import type { CmsLink } from '@omnia/ui/src/lib'
import { CmsLinkComponent, ImageWithFocalPoint, useWindowResize } from '@omnia/ui/src/lib'
import { getBemClassBuilder } from '@omnia/ui/src/lib/lumos-plus/utils/get-bem-class-builder'
import { ModalMode } from '@vista-digital/occ-ui'
import { Modal } from '@vista-digital/occ-ui/src/lib/subcomponents/modal/modal'
import type { FC, PropsWithChildren } from 'react'
import type { ImagePopup } from '../models/popup.types'

const ComponentName = 'ImagePopupModal'
const b = getBemClassBuilder(ComponentName)

interface ImagePopupModalProps {
    popup: ImagePopup
    onClose: VoidFunction
}

export const ImagePopupModal: FC<ImagePopupModalProps> = ({ popup, onClose }) => {
    const { height } = useWindowResize()
    const maxImageHeight = Math.round(height * 0.88)

    return (
        <Modal className={b.block()} show onClose={onClose} mode={ModalMode.Overlay}>
            <ImageLink link={popup.link} onClick={onClose}>
                <ImageWithFocalPoint
                    className={b.element('image')}
                    {...popup.image}
                    dimensions={{
                        height: maxImageHeight,
                    }}
                />
            </ImageLink>
        </Modal>
    )
}

const ImageLink: FC<PropsWithChildren<{ link?: CmsLink; onClick: VoidFunction }>> = ({ children, link, onClick }) => {
    if (!link) {
        return <>{children}</>
    }

    return (
        <CmsLinkComponent link={link} onClick={onClick}>
            {children}
        </CmsLinkComponent>
    )
}

ImagePopupModal.displayName = ComponentName
